import React, { useState, useEffect } from 'react';
import { Modal } from "bootstrap";
import Select from "react-select";
import LoadingScreen from "../util/LoadingScreen";
import Swal from "sweetalert2";
import ApiService from "../util/ApiService";

const ModalPendingDocuments = ({
                                   visible,
                                   onClose,
                                   initialPendingDocs = [], // Valor padrão para evitar erros
                                   ufs = [], // Valor padrão para estados
                                   updatePendingDocsInParent, // Função para atualizar os pendingDocs no componente pai
                               }) => {
    const [pendingDocs, setPendingDocs] = useState(initialPendingDocs); // Estado local para documentos pendentes
    const [currentDoc, setCurrentDoc] = useState(null); // Documento sendo editado
    const [selectedUfDoc, setSelectedUfDoc] = useState(null); // UF selecionado
    const [loadingPage, setLoadingPage] = useState(false); // Controle de carregamento
    const [docNumber, setDocNumber] = useState(""); // Número do documento
    const [typeOfPerson, setTypeOfPerson] = useState(null); // Tipo de pessoa

    // Atualiza pendingDocs local sempre que initialPendingDocs mudar
    useEffect(() => {
        setPendingDocs(initialPendingDocs || []);
    }, [initialPendingDocs]);

    // Abrir modal para edição de documento
    const handleEditDocument = (doc) => {
        setCurrentDoc(doc);
        setSelectedUfDoc(ufs.find(uf => uf.value === doc.state) || null);
        setDocNumber(doc.doc_number || "");
        setTypeOfPerson({
            value: doc.type_of_person,
            label: doc.type_of_person === 1 ? "Física" : "Jurídica",
        });
        const modal = new Modal(document.getElementById('uploadDocumentModal'));
        modal.show();
    };

    // Submeter formulário de documento
    const handleSubmitDocuments = async (event) => {
        event.preventDefault();



        const docFile = event.target.document_file?.files?.[0];
        setLoadingPage(true);
        const formData = new FormData();
        formData.append('file', docFile || "");
        formData.append('doc_number', docNumber);
        formData.append('state', selectedUfDoc?.value || "");
        formData.append('id_type', currentDoc?.id_type || "");
        formData.append('type_of_person', typeOfPerson?.value || "");



        try {
            const response = await ApiService.sendArquivo('post', process.env.REACT_APP_URL_API + 'doc/register', formData);
            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Documento salvo com sucesso!',
                });

                // Atualizar documentos pendentes localmente
                const updatedPendingDocs = pendingDocs.filter(doc => doc.id_type !== currentDoc.id_type);
                setPendingDocs(updatedPendingDocs);
                updatePendingDocsInParent(updatedPendingDocs);

                // Fechar modais
                const uploadModal = Modal.getInstance(document.getElementById('uploadDocumentModal'));
                uploadModal?.hide();
                if (updatedPendingDocs.length === 0) {
                    const pendingModal = Modal.getInstance(document.getElementById('pendingDocumentsModal'));
                    pendingModal?.hide();
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao salvar documento',
                    text: response.data.message,
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    return (
        <>
            {loadingPage && <LoadingScreen />}
            <div className={`modal fade ${visible ? 'show d-block' : ''}`} id="pendingDocumentsModal" tabIndex="-1"
                 aria-labelledby="pendingDocumentsModalLabel" aria-hidden={!visible}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="pendingDocumentsModalLabel">Documentos Pendentes</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                    onClick={() =>onClose()}></button>
                        </div>
                        <div className="modal-body">
                            {pendingDocs.length > 0 ? (
                                pendingDocs.map((doc, index) => (
                                    <div key={index} className="mb-3">
                                        <h5>{doc.name || "Documento sem nome"}</h5>
                                        <button type="button" className="btn btn-primary" onClick={() => handleEditDocument(doc)}>
                                            Enviar Documento
                                        </button>
                                    </div>
                                ))
                            ) : (
                                <div className="alert alert-primary" role="alert">Nenhum documento pendente
                                    encontrado.</div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"
                                    onClick={() =>onClose()}>Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para Upload de Documento */}
            <div className="modal fade" id="uploadDocumentModal" tabIndex="-1"
                 aria-labelledby="uploadDocumentModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="uploadDocumentModalLabel">Cadastro Documento
                                - {currentDoc?.doc_type?.name || currentDoc?.name || "Documento Não Identificado"}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmitDocuments}>
                                {currentDoc?.visible_value === 1 && (
                                    <div className="form-group">
                                        <label>Número</label>
                                        <input type="text" className="form-control" name="doc_number" value={docNumber}  required={currentDoc?.required_value === 1}
                                               onChange={(e) => setDocNumber(e.target.value)} />
                                    </div>
                                )}
                                {currentDoc?.visible_state ===1  && (
                                    <div className="form-group">
                                        <label>Estado</label>
                                        <Select
                                            value={selectedUfDoc}
                                            onChange={setSelectedUfDoc}
                                            options={ufs}
                                            placeholder="Selecionar Estado"
                                            isSearchable
                                            required={currentDoc?.visible_state === 1}
                                            menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }), // Definindo z-index alto
                                                menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                            }}
                                        />
                                    </div>
                                )}

                                {currentDoc?.visible_type_of_person === 1 && (
                                    <div className="form-group">
                                        <label>Tipo</label>
                                        <Select
                                            value={typeOfPerson}
                                            options={typeOptions}
                                            placeholder="Tipo"
                                            isSearchable
                                            onChange={setTypeOfPerson}
                                            required={currentDoc?.required_type_of_person==1}
                                            menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }), // Definindo z-index alto
                                                menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                            }}
                                        />
                                    </div>
                                )}

                                {currentDoc?.visible_file === 1  && (
                                    <div className="form-group">
                                        <label>Comprovante Documento</label>
                                        <input type="file" className="form-control" name="document_file"     required={currentDoc?.required_file === 1} />
                                        <small className="text-secondary">
                                            O formato de arquivo recomendado é <b>PDF</b>
                                        </small>
                                    </div>
                                )}
                                <button type="submit" className="btn btn-primary mt-3" disabled={loadingPage}>
                                    {loadingPage ? "Processando..." : "Cadastrar Documento"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModalPendingDocuments;
